import { Component, OnInit, ViewChild } from '@angular/core';
import { RolesAutocompleteComponent } from '../../common/autocomplete';
import { MdDialogRef } from '@angular/material';
import { FileUploadComunicacionComponent } from '../../common/file-upload-comunicacion/file-upload-comunicacion.component';
import { ComunicacionService, COM_DIALOG_STATE } from '../../../services/comunicacion-service';
import { SpinnerService } from '../../../services/spinner-service';
import {ColaboradorAutocompleteComponent} from "../../common/autocomplete/colaborador-autocomplete/colaborador-autocomplete.component";

@Component({
  selector: 'app-new-comunicacion-dialog',
  templateUrl: './new-comunicacion-dialog.component.html',
  styleUrls: ['./new-comunicacion-dialog.component.scss']
})
export class NewComunicacionDialogComponent implements OnInit {

  @ViewChild(FileUploadComunicacionComponent) fileUpload;
  @ViewChild(RolesAutocompleteComponent) rolesAutocompleteComponent;
  @ViewChild(ColaboradorAutocompleteComponent) colaboradoresAutocompleteComponent;

  constructor(public dialogRef: MdDialogRef<NewComunicacionDialogComponent>,
              private comunicacionService: ComunicacionService,
              private spinnerService: SpinnerService) { }

  public formTitle = 'Nuevo Comunicado';

  public titulo: string;
  public descripcion: string;
  public autor: string;
  public autorId: number;
  public tipoComunicacion: number;
  public prioridad: number;
  public area: any;
  private hasFile = false;

  public colaboradores = [];
  private colaboradoresValid = false;
  public showColabValidErr = false;

  public fileLabel = 'Seleccionar Archivo';

  public comType: any;
  public areaList: any;

  public fileData: any = null;

  dialogState = COM_DIALOG_STATE.NEW;

  comunicacion: any;

  private rolesList = [];

  FILE_OVERRIDE_STATES = {
    NO_OVERRIDE: 'NO',
    CREATE_FILE: 'CREATE',
    UPDATE_FILE: 'UPDATE',
    DELETE_FILE: 'DELETE'
  };

  private fileOverrideState = this.FILE_OVERRIDE_STATES.NO_OVERRIDE;

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.comunicacionService.getComunicacionTipos()
      .subscribe(res => {
        if (res) {
          this.comType = res;
        }
      });
    this.comunicacionService.getComunicacionAreas()
      .subscribe(res => {
        if (res) {
          this.areaList = res;
        }
      });
    this.initializeForm();
  }

  initializeForm() {
    if (this.dialogState === COM_DIALOG_STATE.EDIT) {
      this.transferData('Editar Comunicado');
    } else if (this.dialogState === COM_DIALOG_STATE.CLONE) {
      this.enableSpinner();
      this.comunicacionService.getComunicacionById(this.comunicacion.Id)
        .subscribe(x => {
            this.disableSpinner();
            if (x) {
              this.comunicacion = x;
              this.transferData('Clonar Comunicado');

              // el autor no puede ser colaborador. si se encuentra en la lista de colaboradores, quitarlo
              for (let i = this.colaboradores.length - 1; i > -1; i--) {
                if (this.colaboradores[i].Id === Number(localStorage.getItem('userId'))) {
                  this.colaboradores.splice(i, 1);
                  break;
                }
              }
            }
        },
          (err) => {
            this.disableSpinner();
          });
    }
  }

  transferData(title: string) {
    this.titulo = this.comunicacion.Titulo;
    this.descripcion = this.comunicacion.Descripcion;
    this.autor = this.comunicacion.AutorNombre;
    this.autorId = this.comunicacion.AutorId;
    this.tipoComunicacion = this.comunicacion.TipoComunicacionId;
    this.prioridad = this.comunicacion.PrioridadComunicacionId;
    this.area = this.comunicacion.AreaId;
    if (this.comunicacion.Colaboradores) {
      this.comunicacion.Colaboradores.forEach(col => {
        this.colaboradores.push({Id: col.ColaboradorId, Name: col.Nombre, RolId: -1 });
      });
    }
    this.fileLabel = this.comunicacion.ComunicacionPath === null ? 'Seleccionar Archivo' : 'Archivo: ' + this.comunicacion.ComunicacionPath;
    this.formTitle = title;
    this.hasFile = this.comunicacion.ComunicacionPath !== null;
    this.checkColaboradores();
  }


  /*
    existen 10 caminos distintos segun se esté creando, editando o clonando y sin cambios de adjunto, creando adjunto, editando adjunto o eliminando adjunto
  */

  onSubmit() {
    this.checkColaboradores();
    this.titulo = this.titulo.trim();
    this.descripcion = this.descripcion ? this.descripcion.trim() : '';
    if (this.colaboradoresValid && this.titulo) {

      if (this.dialogState === COM_DIALOG_STATE.EDIT) {
        // edit code
        if (this.hasFile) {
          // si se esta editando y el comunicado posee archivo

          switch (this.fileOverrideState) {
            // no se modifico el archivo, eviamos el path original
            case this.FILE_OVERRIDE_STATES.NO_OVERRIDE:
              this.updateComunicacion(this.comunicacion.ComunicacionPath);
              break;
            // para actualizar archivos usamos el endpoint de actualizar comunicado con adjunto
            case this.FILE_OVERRIDE_STATES.UPDATE_FILE:
              this.updateComunicacionWithAttachment();
              break;
            // para eliminar el adjunto, se envia el update a través del endpoint update sin archivo, con el filePath en null
            case this.FILE_OVERRIDE_STATES.DELETE_FILE:
              this.updateComunicacion(null);
              break;
          }

        } else {

          if (this.fileOverrideState === this.FILE_OVERRIDE_STATES.CREATE_FILE) {
            this.updateComunicacionWithAttachment();
          } else {
            // si la comunicacion no tiene archivo el parametro filePath se envia como null
            this.updateComunicacion(null);
          }

        }

      } else if (this.dialogState === COM_DIALOG_STATE.CLONE) {
        // si se cambia o elimina el archivo adjunto o el comunicado original no tenia archivo, se envia la peticion al endpoint de crear nuevo comunicado en lugar
        // de al endpoint de clonar. El endpoint de clonar SOLO se usa si el comunicado tenia archivo y este no se modifico
        switch (this.fileOverrideState) {
          // no se modifico el archivo, eviamos el path original
          case this.FILE_OVERRIDE_STATES.NO_OVERRIDE:
            // solo enviar al andpoint de clonar si existia un archivo originalmente, si no existia y no se modifico usar el de crear comunicado sin adjunto
            if (this.hasFile) {
              this.cloneComunicacion();
            } else {
              this.createComunicacionNonAttachment();
            }
            break;
          // para crear un archivo o actualizarlo usamos el endpoint de crear comunicado con adjunto
          case this.FILE_OVERRIDE_STATES.CREATE_FILE:
          case this.FILE_OVERRIDE_STATES.UPDATE_FILE:
            this.createComunicacionWithAttachment();
            break;
          // para eliminar el adjunto, se envia el update a través del endpoint update sin archivo, con el filePath en null
          case this.FILE_OVERRIDE_STATES.DELETE_FILE:
            this.createComunicacionNonAttachment();
            break;
        }


      } else {
        // se esta creando una comunicacion con un archivo adjunto
        if (this.fileData) {
          // new with attachment code
          this.createComunicacionWithAttachment();

        } else {
          // se esta creando una comunicacion sin archivo adjunto
          this.createComunicacionNonAttachment();
        }
      }
    } else {
      return;
    }
  }

  rolesChanged(e) {
    if (e.Action === 'add') {
      // Insertar Colaboradores según Rol
      this.comunicacionService.getColaboradoresByRol(e.Id)
        .subscribe(res => {
          if (res) {
            res.forEach(x => {
              this.addColaborador({Id: x.UserId, Name: x.UserName, RolId: e.Id});
            });
            this.checkColaboradores();
          }
        });
      this.rolesList.push(e.Id);
    } else if (e.Action === 'remove') {
      // remover de la lista Colaboradores segun el rol removido
      for (let i = this.colaboradores.length - 1; i > -1; i--) {
        if (this.colaboradores[i].RolId === e.Id) {
          this.colaboradores.splice(i, 1);
        }
      }
      this.rolesList.splice(this.rolesList.indexOf(e.Id), 1);
      // this.selectedRoles = this.selectedRoles.filter(r => r.Id !== id);
      this.checkColaboradores();
    }
    this.setColaboradoresToIgnore();
  }

  addColaborador(e) {
    if (this.dialogState === COM_DIALOG_STATE.NEW) {
      if (this.colaboradores.findIndex(v => v.Id === e.Id) < 0 && e.Id.toString() !== localStorage.getItem('userId')) {
        // si se añade un colaborador desde colaboradoresAutocomplete, no posee rol definido, definir uno generico
        if (!e.hasOwnProperty('RolId')) {
          e.RolId = -1;
        }
        this.colaboradores.push(e);
      }
    } else {

      // añadir si el colaborador no se encuentra en la lista && no sea el usuario logueado (autor) && no se este editando e intentando meter al autor como colaborador
      if (this.colaboradores.findIndex(v => v.Id === e.Id) < 0 &&
          e.Id.toString() !== localStorage.getItem('userId') &&
          !(this.dialogState === COM_DIALOG_STATE.EDIT && e.Id === this.comunicacion.AutorId)) {
        // si se añade un colaborador desde colaboradoresAutocomplete, no posee rol definido, definir uno generico
        if (!e.hasOwnProperty('RolId')) {
          e.RolId = -1;
        }
        this.colaboradores.push(e);
      }
    }

    this.checkColaboradores();
    this.setColaboradoresToIgnore();
  }

  removeColaborador(colab) {
    this.colaboradores.splice(this.colaboradores.findIndex(v => v.Id === colab.Id), 1);
    this.checkRolesIntegrity();
    this.checkColaboradores();
    this.setColaboradoresToIgnore();
  }

  setColaboradoresToIgnore() {
    this.colaboradoresAutocompleteComponent.colaboradoresToIgnore = this.colaboradores.map(x => x.Id);
  }

  checkColaboradores() {
    this.colaboradoresValid = this.colaboradores.length > 0;

    // con esta variable evitamos que se muestre el error de colaboradores antes de empezar a setearlos
    this.showColabValidErr = !this.colaboradoresValid;
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

  openFileDialog() {
    this.fileUpload.click();
  }

  onFileAdded(e) {
    this.fileData = e.FormData;
    this.fileLabel = 'Archivo: ' + e.FileName;
    if (this.dialogState !== COM_DIALOG_STATE.NEW) {
      if (this.hasFile) {
        this.fileOverrideState = this.FILE_OVERRIDE_STATES.UPDATE_FILE;
      } else  {
        this.fileOverrideState = this.FILE_OVERRIDE_STATES.CREATE_FILE;
      }
    }
  }

  // si se eliminan colaboraboradores de la lista uno por uno, eliminar rol del autocomplete
  checkRolesIntegrity() {
    let delRol = true;
    this.rolesList.forEach(rol => {
      this.colaboradores.forEach(col => {
        if (col.RolId === rol) {
          delRol = false;
        }
      });
      if (delRol) {
        this.rolesAutocompleteComponent.deleteRolFromParent(rol);
        this.rolesList.splice(this.rolesList.indexOf(rol), 1);
      }
      delRol = true;
    });
  }

  enableSpinner() {
    this.spinnerService.setShowFlag(true);
  }

  disableSpinner() {
    this.spinnerService.setShowFlag(false);
  }

  createComunicacionNonAttachment() {
    this.enableSpinner();
    this.comunicacionService.saveComunicacionNoFileAdded(
      this.titulo,
      Number(localStorage.getItem('userId')),
      this.tipoComunicacion,
      this.prioridad,
      this.colaboradores.map(item => item.Id),
      [], // clientes, feature futura
      this.descripcion,
      this.area
    )
      .subscribe(res => {
          this.disableSpinner();
          if (res) {
            this.dialogRef.close(true);
          }
        },
        (err) => {
          this.disableSpinner();
        });
  }

  createComunicacionWithAttachment() {
    this.enableSpinner();
    this.comunicacionService.saveComunicacionWithFile(
      this.titulo,
      Number(localStorage.getItem('userId')),
      this.tipoComunicacion,
      this.prioridad,
      this.colaboradores.map(item => item.Id),
      [], // clientes, feature futura
      this.descripcion,
      this.area,
      this.fileData
    )
      .subscribe(res => {
          this.disableSpinner();
          if (res.statusText === 'Created') {
            this.dialogRef.close(true);
          }
        },
        (err) => {
          this.disableSpinner();
        });
  }

  updateComunicacion(filePath) {
    this.enableSpinner();
    this.comunicacionService.updateComunicacion(
      this.comunicacion.Id,
      this.titulo,
      this.comunicacion.AutorId,
      this.tipoComunicacion,
      this.prioridad,
      this.colaboradores.map(item => item.Id),
      [], // clientes, feature futura
      this.descripcion,
      this.area,
      filePath
    )
      .subscribe(res => {
          this.disableSpinner();
          if (res) {
            this.dialogRef.close(true);
          }
        },
        (err) => {
          this.disableSpinner();
        });
  }

  updateComunicacionWithAttachment() {
    this.enableSpinner();
    this.comunicacionService.updateComunicacionWithFile(
      this.comunicacion.Id,
      this.titulo,
      this.comunicacion.AutorId,
      this.tipoComunicacion,
      this.prioridad,
      this.colaboradores.map(item => item.Id),
      [], // clientes, feature futura
      this.descripcion,
      this.area,
      this.fileData
    )
      .subscribe(res => {
          this.disableSpinner();
          if (res.statusText === 'Created') {
            this.dialogRef.close(true);
          }
        },
        (err) => {
          this.disableSpinner();
        });
  }

  cloneComunicacion() {
    this.enableSpinner();
    this.comunicacionService.cloneComuncicacion(
      this.comunicacion.Id,
      this.titulo,
      Number(localStorage.getItem('userId')),
      this.tipoComunicacion,
      this.prioridad,
      this.colaboradores.map(item => item.Id),
      [], // clientes, feature futura
      this.descripcion,
      this.area
    )
      .subscribe(res => {
          this.disableSpinner();
          if (res) {
            this.dialogRef.close(true);
          }
        },
        (err) => {
          this.disableSpinner();
        });
  }

  deleteAttachment() {
    this.fileData = null;
    this.fileLabel = 'Seleccionar Archivo';
      if (this.hasFile) {
        this.fileOverrideState = this.FILE_OVERRIDE_STATES.DELETE_FILE;
      } else  {
        this.fileOverrideState = this.FILE_OVERRIDE_STATES.NO_OVERRIDE;
      }
  }


}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/comunicaciones/new-comunicacion-dialog/new-comunicacion-dialog.component.ts